module.exports = __webpack_public_path__ + "img/battery.0493e585.svg";